import { Backend } from '@/_axios';

/**
 * Created by marcis on 18.3.10.
 */
export default {
  GET_PROJECTS_OVERVIEWS: function ({ commit, state }, { periodFrom, periodTo }) {
    state.overviewsDataLoaded = false;
    Backend.get('/api/projects-overviews', { params: { periodFrom: periodFrom, periodTo: periodTo } }).then((response) => {
      const actualsV1 = {};
      const actualsV2 = {};
      const materialsV1 = {};
      const materialsV2 = {};
      const etc = {};
      response.data.actualsV1.forEach((project) => {
        actualsV1[project.id] = parseInt(project.actuals);
      });
      response.data.actualsV2.forEach((project) => {
        actualsV2[project.id] = parseInt(project.actuals);
      });
      response.data.materialsV1.forEach((material) => {
        materialsV1[material.id] = material;
      });
      response.data.materialsV2.forEach((material) => {
        materialsV2[material.id] = material;
      });
      response.data.etc.forEach((project) => {
        etc[project.id] = parseInt(project.etc) / 100;
      });

      commit(
        'SET_PROJECTS_OVERVIEWS',
        {
          actualsV1: actualsV1,
          actualsV2: actualsV2,
          materialsV1: materialsV1,
          materialsV2: materialsV2,
          etc: etc
        }
      );
    }, (err) => {
      console.log(err);
    });
  },
};
